<template>
  <Skeleton v-if="loading" :class="cn(HEIGHT[size], 'w-24', props.class)" />
  <Button v-else type="submit" :size="size" :disabled="busy || disabled" :class="props.class">
    <Spinner v-if="busy" />
    <slot />
  </Button>
</template>

<script setup lang="ts">
// A skeleton while the page loads. Other buttons stay live, so "Back to login"
// works before the page has loaded.
import type { HTMLAttributes } from "vue";

import { useLoading } from "@/components/kit/loadState";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

const props = withDefaults(
  defineProps<{
    busy?: boolean;
    disabled?: boolean;
    size?: "default" | "sm" | "lg";
    class?: HTMLAttributes["class"];
  }>(),
  { size: "default", class: undefined },
);

// Button's heights.
const HEIGHT = { default: "h-9", sm: "h-8", lg: "h-10" } as const;

const loading = useLoading();
</script>
